export default __webpack_public_path__ + "static/media/sncf.e21ccfc9.png";